<template>
    <div class="page-signup-confirm">

        <template v-if="state === 'pending'">
            <div class="block-title">Проверка кода</div>
            <div class="message">
                Пожалуйста подождите. Идет проверка кода подтверждения.
            </div>

        </template>
        <template v-else-if="state === 'success'">
            <div class="block-title">Регистрация прошла успешно. Добро пожаловать!</div>
            <div class="message">
                Вы будете перенаправлены на главную страницу через <b>{{ timeout }}</b> секунд.
            </div>

        </template>
        <template v-else>
            <div class="block-title">Ссылка больше не действует</div>
            <div class="message">
                К сожалению, ссылка подтверждения регистрации больше не действует.
                Для завершения регистрации воспользуйтесь функцией «Забыл пароль»,
                вам будет отправлена ссылка на восстановление пароля.
                Ссылка сработает так же, как и подтверждение регистрации
            </div>

            <router-link class="accent" to="/user/restore">Забыли пароль?</router-link>
        </template>
    </div>
</template>

<script>
import { updateSession } from '@/common/session.js';
import { sleep } from '@dsee/util/async.js';
import { signupConfirm } from '@/restapi/user/user.js';

export default {
    data() {
        return {
            state: 'pending',
            timeout: 10,
        };
    },
    methods: {
        async checkCode() {
            const tokenId = this.$route.query?.id;

            if (!tokenId) {
                this.state = 'no_code';
                return;
            }

            try {
                const user = await signupConfirm({ tokenId });
                updateSession(user);
            } catch (e) {
                this.state = 'invalid_code';
                return;
            }

            this.state = 'success';

            while (--this.timeout > 0) {
                await sleep(1000);
            }

            this.$router.push('/');
        },
    },
    created() {
        this.checkCode();
    },
};
</script>

<style lang="scss" scoped>
.page-signup-confirm {
    .message {
        font-weight: 400 !important;
    }
}
</style>
